// src/utils/stockNotificationRecipients.ts
// Qui doit voir / recevoir une alerte stock (in-app + push), selon la topologie des lieux.

import type { SiteType } from '../types/site';

export type SiteTypeLike = { type?: SiteType | string; isActive?: boolean };

/**
 * « Vrai » multi-lieux pour les alertes stock :
 * plusieurs PdV, ou plusieurs magasins.
 * 1 PdV seul, 1 magasin seul, ou le duo classique 1 PdV + 1 magasin → PAS multi-lieux.
 */
export function isTrueMultiSiteLayout(sites: SiteTypeLike[]): boolean {
  const active = sites.filter((s) => s.isActive !== false);
  let pos = 0;
  let warehouse = 0;
  for (const s of active) {
    if (s.type === 'point_of_sale') pos += 1;
    else if (s.type === 'warehouse') warehouse += 1;
  }
  return pos > 1 || warehouse > 1;
}

/**
 * Destinataire stock pour un lieu `siteId`.
 * - Hors vrai multi-lieux : tout le monde (filtrage permission ailleurs).
 * - Vrai multi-lieux : uniquement si `assignedSiteIds` contient le site ;
 *   pas d’affectation → pas de notif.
 * - Notif sans `siteId` en vrai multi : ne pas diffuser (ciblage impossible).
 */
export function canReceiveStockSiteNotification(params: {
  isTrueMultiSite: boolean;
  siteId?: string | null;
  assignedSiteIds?: string[] | null;
}): boolean {
  const { isTrueMultiSite, siteId, assignedSiteIds } = params;
  if (!isTrueMultiSite) return true;
  if (!siteId) return false;
  const assigned = Array.isArray(assignedSiteIds)
    ? assignedSiteIds.filter((id): id is string => typeof id === 'string' && id.length > 0)
    : [];
  if (assigned.length === 0) return false;
  return assigned.includes(siteId);
}

export function isStockAlertNotificationType(type: string | undefined | null): boolean {
  return type === 'low_stock' || type === 'out_of_stock';
}
